import axios from "./axios";
import {
	API_GENERATE_PDF,
	API_SALVAGE_LIST,
	API_SALVAGE_PDF,
	API_URL_AUCTION,
	API_URL_BODY_TYPE_FILTERATION,
	API_URL_CAR_INFO_BY_VIN_NUMBER,
	API_URL_CAR_INFO_VIN,
	API_URL_CAR_LISTING,
	API_URL_Compare_GENERATE_PDF,
	API_URL_GENERATE_PDF,
	API_URL_MARKET_VALUE,
	API_URL_MARKET_VALUE_PRICE,
	API_URL_PREMIUM_VIN_DECODE,
	API_URL_PRICE_FILTERATION,
	API_URL_SALE_HISTORY,
	API_URL_SIGNIN,
	API_URL_SIGNUP,
	API_URL_YEAR_FILTERATION,
	API_DEFAULT_FILTER_VALUES,
	API_STRIPE_PRODUCTS,
	API_STRIPE_CREATE_CHECKOUT,
	API_STRIPE_SUBSCRIPTION_STATUS,
	API_STRIPE_CREATE_PORTAL,
	API_STRIPE_REDEEM_CODE,
	API_STRIPE_VALIDATE_CODE,
	API_AUTH_GOOGLE,
	API_USER_PROFILE,
	API_URL_FORGOT_PASSWORD,
	API_URL_RESET_PASSWORD,
	API_BULK_SUBSCRIPTION_CREATE_CHECKOUT,
	API_BULK_SUBSCRIPTION_PURCHASES,
	API_BULK_SUBSCRIPTION_PURCHASE_CODES,
	API_BULK_SUBSCRIPTION_REVOKE_CODE,
	API_BULK_SUBSCRIPTION_STATS,
} from "./urls";

// 1 Car Information by Vin Number API
export const getCarinfoByVin = async (vin) => {
	try {
		const res = await axios.get(`${API_URL_CAR_INFO_BY_VIN_NUMBER}/${vin}`);
		console.log("getCarinfoByVin:res", res);
		return { data: res?.data?.result };
	} catch (error) {
		console.log("getCarinfoByVin:error", error);
		return error;
	}
};

export const generatePDF = async (payload) => {
	try {
		const res = await axios.post(`${API_URL_GENERATE_PDF}`, payload, {
			responseType: "blob",
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const logIn = async (payload) => {
	try {
		const res = await axios.post(`${API_URL_SIGNIN}`, payload);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};
export const signUp = async (payload) => {
	try {
		const res = await axios.post(`${API_URL_SIGNUP}`, payload);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const forgotPassword = async (payload) => {
	try {
		const res = await axios.post(`${API_URL_FORGOT_PASSWORD}`, payload);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const resetPassword = async (payload) => {
	try {
		const res = await axios.post(`${API_URL_RESET_PASSWORD}`, payload);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const generateComparePDF = async (payload) => {
	try {
		const res = await axios.post(`${API_URL_Compare_GENERATE_PDF}`, payload, {
			responseType: "blob", // Important to receive the response as a Blob
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const generateSalvagePDF = async (payload) => {
	try {
		const res = await axios.post(`${API_SALVAGE_PDF}`, payload, {
			responseType: "blob", // Important to receive the response as a Blob
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const generateFinalPDF = async (payload) => {
	try {
		const res = await axios.post(`${API_GENERATE_PDF}`, payload, {
			responseType: "blob", // Important to receive the response as a Blob
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const getCarPremiumDecode = async (vin) => {
	try {
		const res = await axios.get(`${API_URL_PREMIUM_VIN_DECODE}/${vin}`);
		console.log("getCarinfoByVin:res", res);
		return { data: res?.data?.result };
	} catch (error) {
		console.log("getCarinfoByVin:error", error);
		return error;
	}
};

export const carInfoVin = async (vin) => {
	try {
		const res = await axios.get(`${API_URL_CAR_INFO_VIN}/${vin}`);
		console.log("getCarinfoByVin:res", res);
		return { data: res?.data?.result };
	} catch (error) {
		console.log("getCarinfoByVin:error", error);
		return error;
	}
};
export const marketValue = async (vin) => {
	try {
		const res = await axios.get(`${API_URL_MARKET_VALUE_PRICE}?vin=${vin}`);
		return { data: res?.data?.result, vin: res.data.vin };
	} catch (error) {
		return error;
	}
};

// 2 Car Listing API
export const getCarListing = async (
	{
		make,
		price_min,
		price_max,
		year_min,
		year_max,
		model,
		city,
		trim,
		radius,
		mileage,
	},
	currPage,
) => {
	try {
		const res = await axios.get(
			`${API_URL_CAR_LISTING}?&year_min=${year_min}&year_max=${year_max}&make=${make}&model=${model}&zip=${city}&radius=${radius}&page=${currPage}&trim=${trim}&price_max=${price_max}&mileage=${mileage}&price_min=${price_min}`,
		);
		console.log("getCarListing:res", res);
		return { data: res?.data?.result };
	} catch (error) {
		console.log("getCarListing:error", error);
		throw error;
	}
};

export const getSalvageCarListing = async (
	{
		condition,
		make,
		mileage,
		price_min,
		price_max,
		year_min,
		year_max,
		body_style,
		model,
		radius,
		city,
		trim,
		mileage_min,
		mileage_max,
	},
	currPage,
) => {
	try {
		const res = await axios.get(
			`${API_SALVAGE_LIST}?year_min=${year_min}&year_max=${year_max}&manufacturer=${make}&model=${model}&trim=${trim}&radius=${radius}&postal_code=${city}&page=${currPage}&price_max=${price_max}&mileage=${mileage}&price_min=${price_min}`,
		);
		console.log("getCarListing:res", res);
		return { data: res?.data?.data, totalCount: res?.data?.totalCount };
	} catch (error) {
		console.log("getCarListing:error", error);
		throw error;
	}
};

// 3 Sale History API
export const getSaleHistory = async (vin) => {
	try {
		const res = await axios.get(`${API_URL_SALE_HISTORY}/${vin}`);
		console.log("getCarinfoByVin:res", res);
		return res;
	} catch (error) {
		console.log("getCarinfoByVin:error", error);
		return error;
	}
};

// 4 Auction API
export const getAuction = async (vin) => {
	try {
		const res = await axios.get(`${API_URL_AUCTION}/${vin}`);
		console.log("getCarinfoByVin:res", res);
		return res;
	} catch (error) {
		console.log("getCarinfoByVin:error", error);
		return error;
	}
};

// 5. Market value on the basis of Year, car,model
export const getCarMarketValue = async ({
	year,
	make,
	model,
	state,
	mileage_value,
}) => {
	try {
		const res = await axios.get(
			`${API_URL_MARKET_VALUE}?year=${year}&make=${make}&model=${model}&state=${state}&mileage_value=${mileage_value}}`,
		);
		console.log("getCarinfoByVin:res", res);
		return res;
	} catch (error) {
		console.log("getCarinfoByVin:error", error);
		return error;
	}
};

// 6. Car filtered by bodyStyle, price, year
export const getCarByBodyStylePriceYear = async (filter) => {
	const endpoint =
		filter.by === "bodyStyle"
			? API_URL_BODY_TYPE_FILTERATION
			: filter.by === "price"
				? API_URL_PRICE_FILTERATION
				: filter.by === "year"
					? API_URL_YEAR_FILTERATION
					: "";
	const param = filter.by === "bodyStyle" ? filter.value + "/1" : "1";
	try {
		const res = await axios.get(`${endpoint}/${param}`);
		console.log("getCarByBodyStyle:res", res);
		return { data: res?.data?.result };
	} catch (error) {
		console.log("getCarByBodyStyle:error", error);
		return error;
	}
};

export const getDefaultFilterValues = async () => {
	try {
		const res = await axios.get(API_DEFAULT_FILTER_VALUES);
		return res.data;
	} catch (error) {
		return error;
	}
};

// Stripe/Subscription APIs
export const getStripeProducts = async () => {
	try {
		const res = await axios.get(API_STRIPE_PRODUCTS);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const createCheckoutSession = async (priceId) => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.post(
			API_STRIPE_CREATE_CHECKOUT,
			{ priceId },
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const getSubscriptionStatus = async () => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.get(API_STRIPE_SUBSCRIPTION_STATUS, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const createPortalSession = async () => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.post(
			API_STRIPE_CREATE_PORTAL,
			{},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const redeemSubscriptionCode = async (code) => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.post(
			API_STRIPE_REDEEM_CODE,
			{ code },
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const validateSubscriptionCode = async (code) => {
	try {
		const res = await axios.post(API_STRIPE_VALIDATE_CODE, { code });
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

// Google Authentication
export const googleAuth = async (idToken) => {
	try {
		const res = await axios.post(API_AUTH_GOOGLE, { idToken });
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

// User Profile
export const getUserProfile = async () => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.get(API_USER_PROFILE, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const updateUserProfile = async (payload) => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.put(API_USER_PROFILE, payload, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

// Bulk Subscription APIs
export const createBulkCheckoutSession = async (payload) => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.post(
			API_BULK_SUBSCRIPTION_CREATE_CHECKOUT,
			payload,
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const getBulkPurchases = async (params = {}) => {
	try {
		const token = localStorage.getItem("token");
		const queryString = new URLSearchParams(params).toString();
		const url = `${API_BULK_SUBSCRIPTION_PURCHASES}?${queryString}`;

		const res = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const getBulkPurchaseCodes = async (purchaseId, params = {}) => {
	try {
		const token = localStorage.getItem("token");
		const queryString = new URLSearchParams(params).toString();
		const url = `${API_BULK_SUBSCRIPTION_PURCHASE_CODES}/${purchaseId}/codes?${queryString}`;

		const res = await axios.get(url, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const revokeBulkSubscriptionCode = async (codeId, reason) => {
	try {
		const token = localStorage.getItem("token");
		const url = `${API_BULK_SUBSCRIPTION_REVOKE_CODE}/${codeId}/revoke`;

		const res = await axios.post(
			url,
			{ reason },
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			},
		);
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};

export const getBulkSubscriptionStats = async () => {
	try {
		const token = localStorage.getItem("token");
		const res = await axios.get(API_BULK_SUBSCRIPTION_STATS, {
			headers: {
				Authorization: `Bearer ${token}`,
			},
		});
		return { data: res?.data };
	} catch (error) {
		return error;
	}
};
